import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../../shared/types/api.types'
import { createDiscountCodeForAdminApi } from './createDiscountCodeForAdmin.api'
import createDiscountCodeForAdminInitialState from './createDiscountCodeForAdmin.initialState'
import {
  CreateDiscountCodeForAdminErrorResponse,
  CreateDiscountCodeForAdminRequestPayload
} from './createDiscountCodeForAdmin.types'

export const createDiscountCodeForAdmin = createAsyncThunk(
  urls.admin.createDiscountCodeForAdmin,
  async (payload: CreateDiscountCodeForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await createDiscountCodeForAdminApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const createDiscountCodeForAdminSlice = createSlice({
  name: urls.admin.createDiscountCodeForAdmin,
  initialState: createDiscountCodeForAdminInitialState,
  reducers: {
    resetCreateDiscountCodeForAdmin: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createDiscountCodeForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(createDiscountCodeForAdmin.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(createDiscountCodeForAdmin.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as CreateDiscountCodeForAdminErrorResponse
        state.success = null
      })
  }
})

export const { actions: createDiscountCodeForAdminActions, reducer: createDiscountCodeForAdminReducer } =
  createDiscountCodeForAdminSlice
export const { resetCreateDiscountCodeForAdmin } = createDiscountCodeForAdminActions
export default createDiscountCodeForAdminSlice.reducer
